import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Table from "../../Components/DayWiseAnalytics/Table";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ActivityLogsModal from "../../Components/ActiveLogs/ActivityLogsModal";
import SideModal from "../../Components/SideModal";
import { toast } from "react-toastify";

const DayWiseAnalytics = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [showLogs, setShowLogs] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [fetchData, setFetchData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("name");
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t } = useTranslation();


  const initialValues = {
    name: "",
    filterVal: filterValue,
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    return await axios.post(`${Config.apiUrl}/getanalytics`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getOwnersSuccess = (res) => {
    if (res.data.status === "NOK" || res.data.data === false) {
    } else setFetchData(res.data.data);
  };

  const getOwnersError = (res) => { };

  const {
    isLoading,
    mutate: getOwnersMutate,
    error,
    data,
    isRefetching,
    // refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getOwnersSuccess,
    onError: getOwnersError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getOwnersMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getOwnersMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
  };


  //-----------Activity Logs------------------------------------

  const openLogs = async (item) => {
    try {
      setLogsLoading(true);

      const body = new FormData();

      body.append("clientId", item.clientId);

      body.append(
        "startDate",
        moment().subtract(15, "days").format("YYYY-MM-DD")
      );

      body.append(
        "endDate",
        moment().format("YYYY-MM-DD")
      );

      body.append("filterType", "mobile");
      body.append("filterValue", "");

      const response = await axios.post(
        `${Config.apiUrl}/getactivitylogs`,
        body,
        {
          headers: {
            authorization: "Bearer " + user.token,
            "Content-Type":
              "application/x-www-form-urlencoded; charset=UTF-8",
          },
        }
      );

      const logs = Array.isArray(response?.data?.data)
        ? response.data.data
        : response?.data?.data
          ? [response.data.data]
          : [];

      setActivityLogs(logs);

      requestAnimationFrame(() => {
        setShowLogs(true);
      });
    } catch (error) {
      console.error("Activity logs error:", error);

      setActivityLogs([]);

      requestAnimationFrame(() => {
        setShowLogs(true);
      });

      toast.error(
        error?.response?.data?.msg || "Failed to load activity logs"
      );
    } finally {
      setLogsLoading(false);
    }
  };

  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{"Client Current Data"}</Title>
              <Underline />
            </div>
          </div>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoading}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              t={t}
            />
          </div>

          <SideModal
            isOpen={showLogs}
            onClose={() => {
              setShowLogs(false);
              setActivityLogs([]);
            }}
          >
            <ActivityLogsModal
              isOpen={showLogs}
              onClose={() => {
                setShowLogs(false);
                setActivityLogs([]);
              }}
              logs={activityLogs}
              loading={logsLoading}
            />
          </SideModal>

          {!error && !isLoading && data && (
            <TableWrapper>
              <Table
                apiData={fetchData || []}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                userType={user.userType}
                openLogs={openLogs}
              />
              {(error || fetchData.length === 0) && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>

          <div className="flex gap-4 items-end">
            {filter !== "status" && filter !== "paystatus" ? (
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="filterVal">{("")}</Label>
                <Field
                  className="border border-slate-300 rounded-md px-4 focus:ring-1 focus:ring-primary-color focus:border-primary-color py-2 ml-1"
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  inputMode={filter === "mobile" ? "numeric" : "text"}
                  maxLength={filter === "mobile" ? "10" : undefined}
                  pattern={filter === "mobile" ? "[0-9]*" : undefined}
                  value={filterValue}
                  onChange={(e) => {
                    if (filter === "mobile") {
                      const value = e.target.value;
                      // Restrict input to digits only, up to 10 characters
                      if (/^\d{0,10}$/.test(value)) {
                        ChangeHandler(e);
                      }
                    } else {
                      ChangeHandler(e);
                    }
                  }}
                />
              </InputGroup>
            ) : null}

            <InputGroup
              // className="min-w-[120px]"
              style={{ flexBasis: "content" }}
            >
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setFilterValue("");
                }}
              >
                <MenuItem value="name">Name</MenuItem>
              </Select>
            </InputGroup>
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;

export default DayWiseAnalytics;
